module.exports = __webpack_public_path__ + "img/undraw_feedback.4b864263.svg";